import React from 'react';

import { InProgress } from '../in-progress/InProgress.view';

import type { InProgressSize } from '../../types/common.types';

import './LoadingPanel.css';

/**
 * Panel that can be displayed while loading
 */
export const LoadingPanel: React.FC<{
  size?: InProgressSize;
  loadingMessage?: React.ReactNode;
  testId?: string;
}> = ({ size = 'large', loadingMessage = 'Loading…', testId }) => (
  <div className="loading-panel" data-testid={testId}>
    <div className="loading-panel__image">
      <InProgress size={size} />
    </div>
    <div className="loading-panel__message">{loadingMessage}</div>
  </div>
);
